import type { Community } from '~/interfaces/community';

export const getFullCommunityName = (community: Pick<Community, 'name'> | null): string => {
  const trimmedName = community?.name?.trim();
  if (!trimmedName) {
    return 'Community';
  }
  if (trimmedName.toLowerCase().includes('community')) {
    return trimmedName;
  }

  return `${trimmedName} Community`;
};
